import React from 'react';

//Tabletop will be shut down 2020, replaced by Papa Parse
//import Tabletop from 'tabletop';
import {readRemoteFile} from 'react-papaparse';

import scenariosCsv from '../csv/DDIP_Data-Scenarios.csv';
import phasesCsv    from '../csv/DDIP_Data-Phases.csv';
import termsCsv     from '../csv/DDIP_Data-Terms.csv';
import usecasesCsv  from '../csv/DDIP_Data-Usecases.csv';
import textsCsv     from '../csv/DDIP_Data-Texts.csv';

const SHEET_ID = process.env.REACT_APP_SHEET_ID;
const API_KEY = process.env.REACT_APP_API_KEY;

const sheetRanges = {
  scenarios: 'Scenarios!A1:D',
  phases: 'Phases!A1:E',
  usecases: 'Usecases!A1:K',
  terms: 'Terms!A1:C',
  texts: 'Texts!A1:D'
}

export const DataContext = React.createContext();

export class DataProvider extends React.Component {

  state = {
    status: 'initial',
    scenarios: [],
    phases: [],
    usecases: [],
    terms: [],
    texts: []
  };

  loadBackupTables = () => {
    const csvData = {
      scenarios: scenariosCsv ,
      phases:    phasesCsv    ,
      terms:     termsCsv     ,
      usecases:  usecasesCsv  ,
      texts:     textsCsv
    }

    Object.keys(csvData).forEach((key) => {

      readRemoteFile(csvData[key],{
        header: true,
        complete: (results) => {
          var googleData = results.data
          console.log("Result data:", googleData)
          this.setState({
            [key]: googleData,
            status: key + ' loaded'
          });
          console.log("Status:", this.state.status)
        }
      })
    });
  }

  loadAllData = () => {
    Object.keys(sheetRanges).forEach((key) => {
      this.getSheetValues(key, sheetRanges[key]);
    });
  }

  convertTable = (table_data)  => {
    let result = [],
        key, value,
        row,
        i, j;

    for (i = 1; i < table_data.length; i++) {        // start from index 1
        row = {};
        for (j = 0; j < table_data[i].length; j++) {
            key = table_data[0][j];                  // take the value form index zero
                                                     // no following index for the letter
            value = table_data[i][j];                // no following index for the letter
            row[key] = value;
        }
        result.push(row);
    }
    return result;
}

  getSheetValues = async (table, range) =>{
    const request = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${range}?key=${API_KEY}`,
    {
      headers: {
        "Content-Type": "application/json",
      }
    });
    const data = await request.json();
    //      console.log('Values: ', data);
    const dataObjects = this.convertTable (data.values);
    //      console.log('Objects: ', dataObjects);
    this.setState({
      [table]: dataObjects,
      status: table + ' loaded'
    });
    console.log("Status:", this.state.status)
  }

  componentDidMount() {
    this.setState({status: 'loadingData'})
    this.loadAllData();
  }

  render() {
    return (
      <DataContext.Provider
        value={{ ...this.state }}
      >
        {this.props.children}
      </DataContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contexts/dataContext.js